import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-template-thirds',
  templateUrl: './template-thirds.component.html',
  styleUrls: ['./template-thirds.component.scss']
})
export class TemplateThirdsComponent {
  @Input() noPadding = false;
  @Input() border = false;
}
